module.exports = __webpack_public_path__ + "img/maria-rubio.eae7f655.jpg";